<template>
  <v-layout justify-center>
    <v-flex md8 xs12>
      <v-layout row wrap>
        <v-flex xs12>
          <!-- <h6 class="title font-weight-black">{{ $t('tabs.emailInvitation') }}</h6> -->
          <v-layout row wrap>
            <v-flex class="mt-4" xs12>
              <v-text-field
                :error="checkFieldError('intro_mail_title')"
                :label="$t('fields.introTitle')"
                :readonly="!editable"
                counter="180"
                outline
                v-if="!$vuetify.breakpoint.xs"
                v-model="event.intro_mail_title"
              ></v-text-field>
            </v-flex>
            <v-flex class="mt-4" xs12>
              <v-textarea
                :auto-grow="true"
                :error="checkFieldError('intro_mail')"
                :label="$t('fields.intro_text')"
                :readonly="!editable"
                outline
                v-model="event.intro_mail"
              ></v-textarea>
            </v-flex>
            <v-flex class="mt-4" xs12>
              <v-label>{{ $t('labels.technical_details_text') }}</v-label>
              <div class="info-after-box" v-html="introAfter"></div>
            </v-flex>
            <v-flex class="mt-4" xs12 style="margin-top: 16px">
              <v-text-field
                :error="checkFieldError('help_contact')"
                :hint="$t('labels.helpContactInfo')"
                :label="$t('fields.help_contact')"
                :readonly="!editable"
                outline
                v-model="event.help_contact"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['event', 'editable', 'introAfter', 'checkFieldError'],
}
</script>

<style scoped>
.info-after-box {
  background-color: #e6e6e6;
  color: rgb(112, 112, 112);
  font-size: 16px;
  line-height: 18px;
  padding: 7px;

  margin-bottom: 20px;
  cursor: not-allowed;

  border: 2px solid #e8e8e8;
  padding-left: 5px;
  padding-right: 5px;
}
</style>
